import { jsxs as e, jsx as r } from "react/jsx-runtime";
const s = (o) => /* @__PURE__ */ e("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: [
  /* @__PURE__ */ r("path", { d: "M4.33203 5.37109L5.10553 22.9253H18.5881L19.3616 5.37109H4.33203Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M4.07422 2.14844H19.6302", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }),
  /* @__PURE__ */ r("path", { d: "M10.0039 1.07422H13.6995", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }),
  /* @__PURE__ */ r("path", { d: "M15.0859 19.6171L15.3223 8.90625", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }),
  /* @__PURE__ */ r("path", { d: "M8.38281 8.91699L8.60842 19.6278", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }),
  /* @__PURE__ */ r("path", { d: "M11.832 8.91699L11.875 19.6278", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" })
] });
export {
  s as default
};
//# sourceMappingURL=delete.js.map
